<template>
  <div id="app" v-cloak>
    <!--&lt;!&ndash;粒子特效&ndash;&gt;-->
    <!--<vue-particles v-if="islogin" class="particle"-->
    <!--               color="#dedede"-->
    <!--               :particleOpacity="0.7"-->
    <!--               :particlesNumber="80"-->
    <!--               shapeType="circle"-->
    <!--               :particleSize="4"-->
    <!--               linesColor="#dedede"-->
    <!--               :linesWidth="1"-->
    <!--               :lineLinked="true"-->
    <!--               :lineOpacity="0.4"-->
    <!--               :linesDistance="150"-->
    <!--               :moveSpeed="3"-->
    <!--               :hoverEffect="true"-->
    <!--               hoverMode="grab"-->
    <!--               :clickEffect="true"-->
    <!--               clickMode="push"-->
    <!--&gt;-->
    <!--</vue-particles>-->

    <!--登陆-->
    <div class="login-page" v-if="islogin">
      <div class="login-page-back">

      </div>
      <div class="login-page-left">
        <div class="login-page-left-content">
          <div class="login-page-left-content-title">
            WELCOME
          </div>
          <div class="login-page-left-content-msg">
            欢迎使用滑动式测斜仪
          </div>
          <div class="login-page-left-content-qrcode">
            <div class="block">
              <div style="width: 100%;text-align: center;display: inline-block">
                <div style="width: 176px;height: 176px;">
                  <canvas id="appQrcodeCanvas" />
                </div>
                <p style="text-align: center;width: 176px;">
                  扫码下载app
                  <!-- <el-link :href="appUrl" type="success" target="_blank">跳转至下载</el-link> -->
                  <!-- <a :href="appUrl" type="success" target="_blank">跳转至下载</a> -->
                </p>
              </div>
            </div>
          </div>
          <!--<div class="login-page-left-content-back"></div>-->
        </div>
      </div>
      <div class="login-page-right">
        <div class="login-page-right-content-out">
          <div class="login-page-right-content">
            <div class="login-page-right-content-msg">
              请输入用户名和密码
            </div>

            <div class="login-page-right-content-label">
              用户名
            </div>
            <el-input class="login-page-right-content-input" type="text" placeholder="" v-model="username"></el-input>

            <div class="login-page-right-content-form-between"></div>

            <div class="login-page-right-content-label">
              密码
            </div>
            <el-input class="login-page-right-content-input" type="password" placeholder="" v-model="password"></el-input>

            <div class="login-page-right-content-login">
              <div class="login-page-right-content-login-btn" @click="loginIn">
                登录
              </div>
            </div>

            <!-- <p style="text-align:center">
              <show-app-qrcode></show-app-qrcode>
            </p> -->
          </div>
          <div class="login-page-right-content-reflection"></div>
        </div>
      </div>
    </div>

    <!--&lt;!&ndash;登陆&ndash;&gt;-->
    <!--<div class="login-box" v-if="islogin">-->
    <!--  <div>-->
    <!--    <p style="text-align: center">请输入用户名和密码</p>-->
    <!--    <div class="demo-input-suffix" style="margin-bottom: 15px">-->
    <!--      <el-input-->
    <!--              type="text"-->
    <!--              placeholder="用户名"-->
    <!--              suffix-icon="el-icon-message"-->
    <!--              @keydown.13.native="loginIn"-->
    <!--              v-model="username">-->
    <!--      </el-input>-->
    <!--    </div>-->
    <!--    <div class="demo-input-suffix" style="margin-bottom: 15px">-->
    <!--      <el-input-->
    <!--              type="password"-->
    <!--              placeholder="密码"-->
    <!--              suffix-icon="el-icon-goods"-->
    <!--              @keydown.13.native="loginIn"-->
    <!--              v-model="password">-->
    <!--      </el-input>-->
    <!--    </div>-->
    <!--    <el-button type="primary" style="float: right;" @click="loginIn">登录</el-button>-->
    <!--  </div>-->
    <!--</div>-->



    <!--修改密码-->
    <el-dialog title="修改密码" :visible.sync="changePasswordVisible">
      <el-form :model="changePasswordForm" :rules="changePasswordRules" ref="changePasswordFormRef" label-width="150px">
        <el-form-item label="用户名" :prop="'username'">
          <el-input v-model="changePasswordForm.username" autocomplete="off" disabled></el-input>
        </el-form-item>
        <el-form-item label="旧密码" :prop="'oldPassword'">
          <el-input type="password" v-model="changePasswordForm.oldPassword" autocomplete="off" show-password clearable></el-input>
        </el-form-item>
        <el-form-item label="新密码" :prop="'newPassword'">
          <el-input type="password" v-model="changePasswordForm.newPassword" autocomplete="off" show-password clearable></el-input>
        </el-form-item>
        <el-form-item label="再次输入新密码" :prop="'newPasswordAgain'">
          <el-input type="password" v-model="changePasswordForm.newPasswordAgain" autocomplete="off" show-password clearable></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="changePasswordVisible = false">取 消</el-button>
        <el-button type="primary" @click="changePasswordConfirm">提 交</el-button>
      </div>
    </el-dialog>
    <!--主体-->
    <el-container v-if="prepared">
      <el-header>
        <span style="user-select: none;" v-if="!isProfessionalMode" @click="goIntoProfessionalMode">RasberTech</span>
        <span style="user-select: none;" v-if="isProfessionalMode" @click="goIntoProfessionalMode">RasberTech(专业)</span>
        <el-button type="danger" style="float: right;margin-top: 10px" @click="loginOut">登出</el-button>
        <el-button type="primary" style="float: right;margin-top: 10px; margin-right: 10px" @click="changePasswordShow">修改密码</el-button>
        <user-measure-situation v-if="$store.state.userId" style="float: right;margin-right: 10px" />
        <show-app-qrcode style="float: right;margin-right: 10px" />
        
        <!--<user-measure-situation />-->
        <!--<el-button type="success" style="float: right;margin-top: 10px;">测量情况</el-button>-->
      </el-header>
      <router-view/>
    </el-container>
  </div>
</template>

<script>
  import professionalModeService from "./js/service/professionalModeService";
  import {mapActions} from "vuex";
  import UserMeasureSituation from "./components/UserMeasureSituation";
  import $ from 'jquery'; //在需要使用的页面中
  import MD5 from 'js-md5';
  import QRCode from 'qrcode';
  import ShowAppQrcode from './components/ShowAppQrcode.vue';

  export default {
    name: 'App',
    components: {UserMeasureSituation,ShowAppQrcode},
    data () {
      let _this = this;

      return {
        clickCountProfessionalMode: 0,
        timer: null,
        isProfessionalMode: false,
        // qrcodeUrl: 'https://rasbertech.oss-cn-beijing.aliyuncs.com/files%2FRasberMeasure_1.0.9.apk',
        qrcodeUrl: 'https://rasbertech.oss-cn-beijing.aliyuncs.com/files%2FrasberInc+3.8.apk',
        
        username: '',
        password: '',
        islogin: true,
        prepared: false,

        changePasswordForm: {
          username: '',
          oldPassword: '',
          newPassword: '',
          newPasswordAgain: '',
        },
        changePasswordVisible: false,
        changePasswordRules: {
          username: [
            { message: '请输入用户名', required: true, trigger: 'blur' }
          ],
          oldPassword:  [
            { message: '请输入旧密码', required: true, trigger: 'blur' }
          ],
          newPassword:  [
            { message: '请输入新密码', required: true, trigger: 'blur' },
            { message: '长度应当至少6个字符', min: 6, trigger: 'blur' }
          ],
          newPasswordAgain:  [
            { message: '请再次输入新密码', required: true, trigger: 'blur' },
            { message: '长度应当至少6个字符', min: 6, trigger: 'blur' },
            { validator: (rule,value,callback) => {
                // 通过callback触发响应，callback中无内容时为输入正确，其他情况均为错误
                let result = _this.changePasswordForm.newPasswordAgain !== _this.changePasswordForm.newPassword;
                return callback((result) ? result : undefined)
              },
              message: '两次输入的新密码应当一致',
              trigger: 'blur'}
          ],
        },

      }
    },
    methods: {

      loginIn: function () {
        let _this = this;
        let data = {
          username:this.username,
          password:MD5(this.password),
          //                password:this.password
        };
        this.$http.post('/front/user/login', data
        ).then(function (res) {
        // this.$http.post(
        //   this.BASEURL + 'front/user/login', data
        // ).then(function (res) {
          if(res && res.body && res.body.errcode !== -1){
            localStorage.setItem("username",_this.username);
            localStorage.setItem("userId",res.body.data.userId);
            localStorage.setItem("auth_userId",res.body.data.userId);
            localStorage.setItem("auth_timestamp",res.body.data.timestamp);
            this.$store.commit('setUsername',_this.username);
            this.$store.commit('setUserId',res.body.data.userId);
            this.$store.commit('setAuth_userId',res.body.data.userId);
            this.$store.commit('setAuth_timestamp',res.body.data.timestamp);
            this.islogin = false;
            this.prepared = true;
            sessionStorage.setItem('islogin',false);
            sessionStorage.setItem('prepared',true);
          }else{
            if(res && res.body && res.body.errcode === -1){
              this.$message(res.body.msg);
            }else{
              this.$message('登录错误，请检查网络');
            }
          }
        }).catch(function (res) {
          console.log('res',res)
          this.$message(res);
          this.islogin = true;
          this.prepared = false;
          sessionStorage.setItem('islogin',true);
          sessionStorage.setItem('prepared',false);
        })
      },
      loginOut:function () {
        sessionStorage.clear();
        localStorage.clear();
        this.$store.commit('setUserId','');
        this.$store.commit('setUsername','');
        this.$store.commit('setAuth_userId','');
        this.$store.commit('setAuth_timestamp','');
        location.reload();
      },
      /**
       * 清空timer
       */
      clearProfessionalModeTimer () {
        let _this = this;
        _this.clickCountProfessionalMode = 0;
        _this.timer = null;
      },
      goIntoProfessionalMode () {
        let _this = this;
        // 三秒内点5次切换模式
        if(_this.timer === null){
          _this.timer = setTimeout(()=>{
            _this.clearProfessionalModeTimer()
          },3000)
        }

        // 计数
        _this.clickCountProfessionalMode ++;

        if(_this.clickCountProfessionalMode === 5){
          _this.clearProfessionalModeTimer();
          // 进入专业模式or取消专业模式
          professionalModeService.toggle()
          // _this.$store.commit('setIsProfessionalMode');
        }

        // 获取是否是专业模式
        _this.isProfessionalMode = professionalModeService.getState();
        console.log('_this.isProfessionalMode',_this.isProfessionalMode)
      },
      changePasswordShow () {
        let _this = this;
        // 设置用户名
        _this.changePasswordForm.username = _this.$store.state.username;
        // 清空其他字段
        _this.changePasswordForm.oldPassword = '';
        _this.changePasswordForm.newPassword = '';
        _this.changePasswordForm.newPasswordAgain = '';
        // 显示弹框
        _this.changePasswordVisible = true;
      },
      changePasswordConfirm () {
        let _this = this;
        _this.$refs['changePasswordFormRef'].validate((valid) => {
          if (!valid) {
            console.log('error submit!!');
            return false;
          } else {
            // 发送请求
            _this.$http.post('/front/user/changePwd',{
                username: _this.changePasswordForm.username,
                oldPassword: MD5(_this.changePasswordForm.oldPassword),
                newPassword: MD5(_this.changePasswordForm.newPassword),
              }, {
                params: {
                  auth_userId:_this.$store.state.auth_userId,
                  auth_timestamp:_this.$store.state.auth_timestamp,
                  token:MD5(`userId=${_this.$store.state.auth_userId}&timestamp=${_this.$store.state.auth_timestamp}&salt=rasberCloud`),
                },
              }).then(function (res) {
              if(res && res.body.errcode && res.body.errcode === -1){
                _this.$message.error(res.body.msg);
              }else{
                _this.$message.success(`修改密码成功，即将返回登陆界面`);
                setTimeout(()=>{
                  _this.loginOut();
                },1000)
              }
            }).catch(function (rej) {
              _this.$message.error(rej);
            })
          }
        });
      }
    },
    mounted:function () {
      $("#app").height(window.innerHeight).width(window.innerWidth);
      $(window).resize(function() {
        $("#app").height(window.innerHeight).width(window.innerWidth);
      });
      if(sessionStorage.getItem('islogin') === 'false'){
        this.islogin = false;
      }else{
        this.islogin = true;
      }
      if(sessionStorage.getItem('prepared') === 'true'){
        this.prepared = true;
      }else {
        this.prepared = false;
      }

      var canvas = document.getElementById('appQrcodeCanvas');
      // console.log('this.appUrl',this.qrcodeUrl);
      QRCode.toCanvas(canvas, this.qrcodeUrl, {width: 176}, function (error) {
        if (error) {
          console.error(error)
        }
        console.log('success!');
      });
    }
  }
</script>

<style>

</style>
